const toneMap = {
  candy: "bg-candy-tint text-candy-dark border-candy",
  pink: "bg-pink-tint text-ink border-pink",
  yellow: "bg-yellow-tint text-ink border-yellow",
  mint: "bg-mint-tint text-ink border-mint",
  ink: "bg-ink text-white border-ink",
  paper: "bg-white text-ink border-ink",
};

/** GeometricBadge — chip with 2px border + hard shadow, uppercase mono label */
export const GeometricBadge = ({
  children,
  tone = "candy",
  shape = "pill", // pill | square | tag
  size = "md",
  className = "",
  ...rest
}) => {
  const shapeCls =
    shape === "square" ? "rounded-lg" : shape === "tag" ? "rounded-md -skew-x-6" : "rounded-full";
  const sizeCls =
    size === "sm"
      ? "px-2.5 py-1 text-2xs"
      : size === "lg"
        ? "px-4 py-2 text-xs"
        : "px-3 py-1.5 text-2xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 border-2 font-mono font-semibold uppercase tracking-[0.22em] shadow-sticker-xs ${shapeCls} ${sizeCls} ${toneMap[tone]} ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
};

/** MonoTag — tiny mono overline used for section eyebrows */
export const MonoTag = ({ children, className = "", ...rest }) => (
  <span className={`t-eyebrow inline-block ${className}`} {...rest}>
    {children}
  </span>
);

export default GeometricBadge;
